import {useState, useLayoutEffect, useEffect} from 'react';
import LoaderUtil from '../../../utils/loader';
import Animation from './animation';
import Language from '../../../language';
import {isMobile} from '../../../utils/viewport';

export default () => {
    const [progress, setProgress] = useState(null),
          [loaded, setLoaded] = useState(false),
          [clicked, setClicked] = useState(false),
          [initialized, setInitialized] = useState(false);

    useEffect(() => {
        if(!initialized) {
            if(isMobile()) 
                Animation.init();
            else
                Animation.start();
            
            setInitialized(true);
        }
        // return () => Animation.stop();
    }, [initialized]);

    useLayoutEffect(() => {
        if(progress === null) {
            setProgress(0);

            LoaderUtil.loader({
                onComplete: () => {
                    window.dispatchEvent(new CustomEvent('assets.loaded'));
                    setLoaded(true);
                    Animation.contentLoaded();
                },
                onProgress: pg => setProgress(pg),
                onError: () => console.log(`Error`),
            }).start(100);
        }
    }, [progress]);

    return (
        <>
            <div className="screen loader animate__animated animate__slow" onClick={e => {
                if(loaded) {
                    window.dispatchEvent(new CustomEvent('loader.click'));
                    setClicked(true);
                }
            }}>
                <div className="animation-block">
                    <div className="name">EXITO</div>
                    <div className="loader-animation"></div>
                </div>
                <div className="progress-block">
                    <div className="progress" style={{width: `${(isMobile() ? 940 : 1413) * (progress || 0)}px`}}></div>
                    <div className={`status animate__animated animate__infinite ${!loaded ? 'animate__pulse' : (clicked ? '' : 'animate__flash animate__slower')}`}>{loaded ? Language('layers.loader.loaded') : Language('layers.loader.loading')}</div>
                </div>
            </div>
        </>
    )
}